import Swiper, { Pagination } from 'swiper'

const gallerySliderInstances = [];
const gallerySliderElements = document.querySelectorAll('.gallery-slider');

if (gallerySliderElements.length) {
    for (let i = 0; i < gallerySliderElements.length; i++) {
        gallerySliderInstances[i] = {
            init: false,
            instance: null,
            element: gallerySliderElements[i],
        };
    }
}

function gallerySlidersInit() {
    if (gallerySliderInstances.length === 0) {
        return
    }

    for (let i = 0; i < gallerySliderElements.length; i++) {
        if (! gallerySliderInstances[i].init) {
            gallerySliderInstances[i].init = true;

            gallerySliderInstances[i].instance = initializeContentSlider(gallerySliderInstances[i].element, i % 2 === 0);
        }
    }
}
gallerySlidersInit();
window.addEventListener('resize', gallerySlidersInit);

function unwrapAcfInnerBlocks(slider) {
    const wrapper = slider.querySelector('.swiper-wrapper');
    if (!wrapper) {
        return;
    }

    const innerBlocks = wrapper.firstElementChild;
    if (!innerBlocks || !innerBlocks.classList.contains('acf-innerblocks-container')) {
        return;
    }

    while (innerBlocks.firstChild) {
        wrapper.appendChild(innerBlocks.firstChild);
    }

    innerBlocks.remove();
}

function initializeContentSlider(slider) {
    unwrapAcfInnerBlocks(slider);

    const slides = slider.querySelectorAll('.swiper-slide');
    const titlePagination = slider.querySelectorAll('.pagination-titles');

    return new Swiper(slider, {
        modules: [ Pagination ],
        slidesPerView: 1,
        pagination: {
            el: '.swiper-pagination, .swiper-pagination-custom',
            clickable: true,
            renderBullet: function(index, className) {
                if (0 === titlePagination.length) {
                    return '<span class="swiper-pagination-bullet"></span>';
                }

                const title = slides[index].getAttribute('data-title');
                return '<div class="' + className + '">' + title + '</div>';
            },
        },
    });
}
